module.exports = __webpack_public_path__ + "static/media/table.002ee418.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/table.svg
// module id = 842
// module chunks = 0